import React from "react"
import { Navigate, useLocation, useSearchParams } from "react-router"
import { routeNames } from "src/router/route-names"
import { UserProvider } from "src/hooks/use-user"
import { isSessionValid } from "@myvp/shared/src/functions/is-session-valid"
import * as authModel from "src/models/auth.model"
import { getLocale } from "src/i18n/get-locale"
import AppPolicyModal from "src/components/app-policy-modal"
import { useI18nState } from "@myvp/shared/src/i18n/i18n-state-provider"

function RedirectToLogin({ from }: { from: string }) {
  const { updateIntl } = useI18nState()
  const { search } = useLocation()

  React.useEffect(() => {
    authModel.removeUserMetadata()
    updateIntl(getLocale())
  }, [updateIntl])

  return (
    <Navigate
      replace
      to={{ pathname: routeNames.login(), search }}
      state={{ from }}
    />
  )
}

const AuthenticatedRoute = (props: {
  Fallback?: React.ComponentType
  children?: React.ReactNode
}) => {
  const Fallback = props.Fallback
  const { pathname, search } = useLocation()
  const [searchParams] = useSearchParams()

  const id = searchParams.get("id")
  if (id) {
    return (
      <Navigate
        replace
        to={{ pathname: routeNames.determineUser(), search }}
        state={{ from: pathname }}
      />
    )
  } else if (!isSessionValid()) {
    if (Fallback) {
      return <Fallback />
    }
    // oxlint-disable-next-line no-console
    console.log("Invalid myvp-sesttl, redirecting to login")
    return <RedirectToLogin from={pathname} />
  }

  return (
    <UserProvider>
      {({ isUserApiFetching, isUserLoggedIn }) => {
        if (isUserApiFetching) {
          return null
        }
        if (!isUserLoggedIn) {
          if (Fallback) {
            return <Fallback />
          }
          return (
            <Navigate replace to={{ pathname: routeNames.login(), search }} />
          )
        } else {
          // NOTE: MYVC-25978 DO NOT CALL NAVIGATE WHEN AUTHENTICATED
          // it will conflict with the setSearchParams call in useDidUpdate(userStudies) in use-user
        }

        return (
          <>
            <AppPolicyModal />
            {props.children}
          </>
        )
      }}
    </UserProvider>
  )
}

export default AuthenticatedRoute
